<template>
	<div>
		<transportista-modals :modelName="model"></transportista-modals>
		<pui-datatable :modelName="model" :actions="actions" :modelColumnDefs="columnDefs" showFilterListBtn></pui-datatable>
	</div>
</template>

<script>
/* eslint-disable */
import TransportistaActions from './TransportistaActions';
import TransportistaModals from './TransportistaModals';

export default {
	name: 'transportistagrid',
	components: {
		TransportistaModals
	},
	data() {
		return {
			model: 'transportista',
			actions: TransportistaActions.gridactions,
			columnDefs: {
				fecbaja: { withoutHours: true }
			}
		};
	}
};
</script>

<style lang="postcss" scoped></style>

<i18n>
{
    "en": {
        "grid.transportista.idtransportista": "Code",
        "grid.transportista.nombre": "Name",
        "grid.transportista.cif": "Tax identifier",
        "grid.transportista.observaciones": "Comments",
		"grid.transportista.fechacreacion":"Creation date",
		"grid.transportista.indbaja":"Ind. Disabled",
		"grid.transportista.baja":"Disabled",
		"grid.transportista.fecbaja":"Disabled date"
    },
    "es": {
        "grid.transportista.idtransportista": "Código",
        "grid.transportista.nombre": "Nombre",
        "grid.transportista.cif": "Identificador fiscal",
        "grid.transportista.observaciones": "Observaciones",
		"grid.transportista.fechacreacion":"Fecha creación",
		"grid.transportista.indbaja":"Ind. Baja",
		"grid.transportista.baja":"Baja",
		"grid.transportista.fecbaja":"Fecha baja"
    },
    "ca": {
        "grid.transportista.idtransportista": "Codi",
        "grid.transportista.nombre": "Nom",
        "grid.transportista.cif": "Identificador fiscal",
        "grid.transportista.observaciones": "Observacions",
		"grid.transportista.fechacreacion":"Data creació",
		"grid.transportista.indbaja":"Ind. Baixa",
		"grid.transportista.baja":"Baixa",
		"grid.transportista.fecbaja":"Data baixa"
    }
}
</i18n>
